// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app {\n  margin: 0 auto;\n  padding: 1rem 0;\n  min-width: 640px;\n  width: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
